export default __webpack_public_path__ + "static/media/icon_task.e8fd678c.svg";